import React from "react";

import SeedParentPage from "./views/index";
import { RandomDataProvider } from "./contexts/RandomDataContext";
import { CustomizedDataProvider } from "./contexts/CustomizedDataContext";
import { ConfigurationProvider } from "./contexts/ConfigurationContext";

/**
 * Main Seeder page component that provides all necessary contexts for seeding functionality
 * @returns {JSX.Element} The seeder page with context providers wrapped around SeedParentPage
 */
const SeederPage = () => {
	return (
		<RandomDataProvider>
			<CustomizedDataProvider>
				<ConfigurationProvider>
					<SeedParentPage />
				</ConfigurationProvider>
			</CustomizedDataProvider>
		</RandomDataProvider>
	);
};

export default SeederPage;
